import React, { useEffect, useMemo, useState } from "react";
import './styles.css';
import Card from "../Card";
import DateTimeInput from "../DateTimeInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk, faXmark } from "@fortawesome/free-solid-svg-icons";
import FloatingActions, { FloatingAction } from "../FloatingActions";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from "@/store/useRouter/types";
import useAppData from "@/store/useAppData";
import axios from "axios";
import useDeviceType from "@/Utils/useDeviceType";
import FlightListComp from "../FlightList";
import DialogWindow from "../DialogWindow";
import { DeicingItem } from "../DeicingList/types";
import { FluidRationTemperature } from "../DeicingForm";

interface Option {
    value: string;
    label: string;
}

interface DeicingFormProps {
    weatherCodes?: Option[];
    operationCode?: string | null;
    onSubmit?: (data: DeicingFormData | null) => void;
}

export interface DeicingFormData {
    id: string;
    date: string;

    type1Start: string | null;
    type1End: string | null;
    type1Deice: DeicingFormItem[];
    //type1FluidConsumption: number | null;
    //fluidRatio: string | null;

    type2Start: string | null;
    type2End: string | null;
    type2Deice: DeicingFormItem[];
    //type2FluidConsumption: number | null;
    //fluid2Ratio: string | null;
    //waterConsumption: number | null;
    //water2Consumption: number | null;

    type3FluidConsumption: number | null;

    aircraft: string | null;
    stand: string | null;
    standName?: string | null;
    company?: number | null;
    companyName?: string | null;
    aircraftType: string;
    aircraftRegistration: string;
    flightNumber: string;

    oat: number | null;
    wingTemperature: number | null;
    weatherCode: number | null;
    note: string;

    supervisor: string;
    checked: boolean;

    lastModified: string | null;
    modifiedBy: number | null;
    checkedBy: number | null;
    modifiedByName: string | null;
    checkedByName: string | null;
    repeatDeicingReason?: number | null;
    noteRepeatDeicing: string;
    oneTwoDeice: string | null;
    stockName: string | null;
}

export interface DeicingFormItem {
    type1FluidConsumption: number | null;
    fluidRatio: string | null;
    waterConsumption: number | null;
    note?: string | null;
}

const toLocalDate = (date: Date): string => {
    const offset = date.getTimezoneOffset();
    return new Date(date.getTime() - offset * 60_000)
        .toISOString()
        .slice(0, 10);
};

// const toLocalDateTime = (date: Date): string => {
//   const offset = date.getTimezoneOffset();
//   return new Date(date.getTime() - offset * 60_000)
//     .toISOString()
//     .slice(0, 16);
// };

// const toLocalDateTime = (timestamp: number): string => {
//   // const offset = date.getTimezoneOffset();
//   // return date.getTime() - offset * 60_000;

//   const date = new Date(timestamp);
//   const offset = date.getTimezoneOffset();

//   return new Date(date.getTime() - offset * 60_000)
//     .toISOString()
//     .slice(0, 16);
// };

export const toLocalDateTime = (value: string | Date): string => {
    const date = new Date(value);
    //const offset = date.getTimezoneOffset();

    return new Date(date.getTime() /*- offset * 60000*/)
        .toISOString()
        .slice(0, 16);
};

export const toLocalDateTimeOffset = (value: string | Date): string => {
    const date = new Date(value);
    const offset = date.getTimezoneOffset();

    return new Date(date.getTime() - offset * 60000)
        .toISOString()
        .slice(0, 16);
};

interface aircraftItem {
    value: string;
    label: string;
    uniqueId?: string;
    stand?: null,
    company?: null,
    aircraftType?: "",
    aircraftRegistration?: "",
    flightNumber?: "",
}

interface valueItem {
    value: string;
    label: string;
}

const DeicingCheckForm: React.FC<DeicingFormProps> = ({
    weatherCodes = [],
    operationCode,
    onSubmit,
}) => {

    const loggedUser = useAppData(state => state.user);
    const selectedDeicing = useAppData(state => state.selectedDeicing);
    const selectedStock = useAppData(state => state.selectedStock);

    const [stands, setStands] = useState<valueItem[]>([]);
    const [companies, setCompanies] = useState<valueItem[]>([]);
    const [repeatDeicingReason, setRepeatDeicingReason] = useState<valueItem[]>([]);
    const [aircraftList, setAircraftList] = useState<aircraftItem[]>([]);
    const [weatherList, setWeatherList] = useState<valueItem[]>([]);
    const deviceType = useDeviceType();
    const [oneTwoDeice, setOneTwoDeice] = useState<"oneDeice" | "twoDeice">("oneDeice");
    const [displayFlightList, setDisplayFlightList] = useState<boolean>(false);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [checkedState, setCheckedState] = useState<boolean>(false);
    const [checkedByNameState, setCheckedByNameState] = useState<string | null>(null);
    const [weatherCodeState, setWeatherCodeState] = useState<number | null>(null);
    const [fluidRatioTemperatureState, setFluidRatioTemperatureState] = useState<FluidRationTemperature | null>();

    const [formData, setFormData] = useState<DeicingFormData[]>([]);



    // const [leftFluidRation = "", rightFluidRatio = ""] = (formData?.fluidRatio ?? "").split("/");
    // const [leftFluid2Ration = "", rightFluid2Ratio = ""] = (formData?.fluid2Ratio ?? "").split("/");

    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );

    useEffect(() => {

        if (selectedDeicing) {
            const init = async () => {
                await loadAirlines();
                await loadWeatherList();
                await loadRepeatDeicingReason();

                await loadDeicing(selectedDeicing);
            };

            init();
        } else {
            const init = async () => {
                await loadAirlines();
                await loadWeatherList();
            };

            init();
        }
    }, []);

    const handleSubmit = async () => {

        for (const formItem of formData) {
            await updateDeicing(formItem);
        }

        // if (selectedDeicing && operationCode !== "repeatDeicing") {
        //     await updateDeicing(selectedDeicing, formData);

        //     await removeDeicingItem(selectedDeicing);

        //     if (formData?.type1Deice?.length) {
        //         for (const deicingItem of formData.type1Deice) {

        //             if (deicingItem?.fluidRatio && deicingItem?.type1FluidConsumption && deicingItem?.waterConsumption) {
        //                 await insertDeicingItem(deicingItem, selectedDeicing, "type1Deice");
        //             }
        //         }
        //     }

        //     if (formData?.type2Deice?.length) {
        //         for (const deicingItem of formData.type2Deice) {

        //             if (deicingItem?.fluidRatio && deicingItem?.type1FluidConsumption && deicingItem?.waterConsumption) {
        //                 await insertDeicingItem(deicingItem, selectedDeicing, "type2Deice");
        //             }
        //         }
        //     }
        // } else {
        //     const deicingId = await insertDeicing(formData);

        //     if (formData?.type1Deice?.length) {
        //         for (const deicingItem of formData.type1Deice) {

        //             if (deicingItem?.fluidRatio && deicingItem?.type1FluidConsumption && deicingItem?.waterConsumption) {
        //                 await insertDeicingItem(deicingItem, deicingId, "type1Deice");
        //             }
        //         }
        //     }

        //     if (formData?.type2Deice?.length) {
        //         for (const deicingItem of formData.type2Deice) {

        //             if (deicingItem?.fluidRatio && deicingItem?.type1FluidConsumption && deicingItem?.waterConsumption) {
        //                 await insertDeicingItem(deicingItem, deicingId, "type2Deice");
        //             }
        //         }
        //     }
        // }

        router.go({ key: RouterStoreItemKey.LISTITEMS });

        // onSubmit?.({
        //   ...formData,
        //   lastModified: toLocalDateTime(new Date()),
        //   modifiedBy: currentUserName,
        //   checkedBy: formData.checked ? currentUserName : "",
        // });
    };

    const actions: FloatingAction[] = [
        {
            key: "cancel",
            label: "Zrušit",
            // icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: () => {
                router.go({ key: RouterStoreItemKey.LISTITEMS });
                //onSubmit?.(null)
            },
        },
        {
            key: "save",
            label: "Uložit",
            // icon: <FontAwesomeIcon icon={faFloppyDisk} />,
            onClick: () => handleSubmit(),
        }
    ];

    const fluidRatioVsFluidConsumption = (
        fluidRatio: string,
        fluidConsumption: number,
        waterConsumption: number,
        toleranceDown = 0,
        toleranceUp = 7
    ): boolean => {
        const [fluidRatioValue, waterRatioValue] = fluidRatio
            .split("/")
            .map(Number);

        const fluid = Number(fluidConsumption);
        const water = Number(waterConsumption);

        if (
            !Number.isFinite(fluidRatioValue) ||
            !Number.isFinite(waterRatioValue) ||
            !Number.isFinite(fluid) ||
            !Number.isFinite(water) ||
            fluidRatioValue + waterRatioValue === 0 ||
            fluid + water === 0
        ) {
            return false;
        }

        const expectedFluidPercent =
            (fluidRatioValue / (fluidRatioValue + waterRatioValue)) * 100;

        const actualFluidPercent =
            (fluid / (fluid + water)) * 100;

        const min = expectedFluidPercent - toleranceDown;
        const max = expectedFluidPercent + toleranceUp;

        return actualFluidPercent >= min && actualFluidPercent <= max;
    };

    const checkFluidMaxRatio = (
        fluidRatio: string | null
    ): boolean => {

        if (fluidRatio) {
            const fluiRatio = fluidRatio.split("/")[0];

            if (fluiRatio) {
                return Number(fluidRatio.split("/")[0]) <= 69;
            }
        }

        return true;
    };

    const deicingDurationMinutes = useMemo(() => {
        const starts = formData
            .flatMap(item => [item.type1Start, item.type2Start])
            .filter(Boolean)
            .map(value => new Date(value ?? "").getTime())
            .filter(Number.isFinite);

        const ends = formData
            .flatMap(item => [item.type1End, item.type2End])
            .filter(Boolean)
            .map(value => new Date(value ?? "").getTime())
            .filter(Number.isFinite);

        if (!starts.length || !ends.length) {
            return 0;
        }

        const firstStart = Math.min(...starts);
        const lastEnd = Math.max(...ends);

        if (lastEnd < firstStart) {
            return 0;
        }

        return Math.round((lastEnd - firstStart) / 60_000);
    }, [formData]);

    const totalConsumption = useMemo(() => {
        let sum = 0;

        formData.forEach(formDataItem => {
            formDataItem.type1Deice?.forEach(item => {
                sum += Number(item.type1FluidConsumption) || 0;
            });

            formDataItem.type2Deice?.forEach(item => {
                sum += Number(item.type1FluidConsumption) || 0;
            });
        })


        return sum;
    }, [formData]);

    const waterConsumption = useMemo(() => {

        let sum = 0;

        formData.forEach(formDataItem => {
            formDataItem.type1Deice?.forEach(type1De => {
                sum += Number(type1De.waterConsumption) || 0;
            })

            formDataItem.type2Deice?.forEach(type2De => {
                sum += Number(type2De.waterConsumption) || 0;
            })
        });

        return sum;

        // return (
        //   Number(formData.type1FluidConsumption || 0) +
        //   Number(formData.type2FluidConsumption || 0)
        // );
    }, [formData]);

    const fluidType2Consumption = useMemo(() => {
        let sum = 0;

        formData.forEach(formDataItem => {
            sum += Number(formDataItem.type3FluidConsumption) || 0;
        })


        return sum;
    }, [formData]);

    // const waterConsumption = useMemo(() => {
    //   return (
    //     Number(formData.waterConsumption || 0) +
    //     Number(formData.water2Consumption || 0)
    //   );
    // }, [
    //   formData.waterConsumption,
    //   formData.water2Consumption,
    // ]);

    // const deicingDate = useMemo(() => {
    //     const date = formData.type1Start ?? formData.type2Start;

    //     return date ? new Date(date) : undefined;
    // }, [formData.type1Start, formData.type2Start]);

    const updateField = <K extends keyof DeicingFormData>(
        field: K,
        value: DeicingFormData[K]
    ) => {
        setFormData(previous => ({
            ...previous,
            [field]: value,
            lastModified: toLocalDateTimeOffset(new Date()),
            modifiedBy: Number(loggedUser?.id!),
        }));
    };

    const updateFieldData = <K extends keyof DeicingFormData>(
        id: DeicingFormData["id"],
        field: K,
        value: DeicingFormData[K]
    ) => {
        setFormData(previous =>
            previous.map(item =>
                item.id === id
                    ? {
                        ...item,
                        [field]: value,
                        lastModified: toLocalDateTimeOffset(new Date()),
                        modifiedBy: Number(loggedUser?.id),
                    }
                    : item
            )
        );
    };

    const setCurrentTime = (
        field: "type1Start" | "type1End" | "type2Start" | "type2End"
    ) => {
        updateField(field, toLocalDateTimeOffset(new Date()));
    };

    const handleCheckedChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setCheckedState(event.target.checked);
        setCheckedByNameState(loggedUser?.name2 ?? null);

        // setFormData(previous => ({
        //     ...previous,
        //     checked,
        //     checkedBy: checked ? Number(loggedUser?.id!) : null,
        //     checkedByName: checked ? loggedUser?.name2 ?? null : null,
        //     lastModified: toLocalDateTimeOffset(new Date()),
        //     modifiedBy: Number(loggedUser?.id!),
        // }));
    };

    const loadDeicing = async (id: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicing/get",
                    data: {
                        id: id
                    }
                })
            );

            if (res?.data?.deicing?.length > 0) {
                await loadDeicings(res?.data?.deicing[0].aircraftRegistration, res?.data?.deicing[0].flightNumber);
                setCheckData(res?.data?.deicing[0]);
            }
        } catch (err) {
            throw err;
        }
    }

    const getFluidRatioTemperature = async (temperature: number) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/fluidratiotemperature/get",
                    data: {
                        temperature: temperature
                    }
                })
            );

            if (res?.data?.fluidRatioTemperature?.length > 0) {
                setFluidRatioTemperatureState(res?.data?.fluidRatioTemperature[0]);
            }
        } catch (err) {
            throw err;
        }
    }

    const setCheckData = (deicing: DeicingFormData) => {
        if (deicing?.checked) {
            setCheckedState(true);
        }

        if (deicing?.weatherCode) {
            setWeatherCodeState(deicing.weatherCode);
        }

        if (deicing?.checkedByName) {
            setCheckedByNameState(deicing.checkedByName);
        }
    }

    const loadDeicings = async (aircraftRegistration: string, flightNumber: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicing/get",
                    data: {
                        aircraftRegistration: aircraftRegistration,
                        flightNumber: flightNumber
                    }
                })
            );

            if (res?.data?.deicing?.length > 0) {

                const deicings: DeicingFormData[] = [];

                for (const deicing of res.data.deicing) {

                    deicing.type1Start = deicing?.type1Start ? toLocalDateTime(deicing.type1Start) : null;
                    deicing.type1End = deicing?.type1End ? toLocalDateTime(deicing.type1End) : null;

                    deicing.type2Start = deicing?.type2Start ? toLocalDateTime(deicing.type2Start) : null;
                    deicing.type2End = deicing?.type2End ? toLocalDateTime(deicing.type2End) : null;

                    const type1Deice = await getDeicingItem(deicing.id, "type1Deice");
                    const type2Deice = await getDeicingItem(deicing.id, "type2Deice");

                    if (type1Deice?.length > 0) {
                        deicing.type1Deice = type1Deice;
                    } else {
                        deicing.type1Deice = [];
                    }

                    if (type2Deice?.length > 0) {
                        deicing.type2Deice = type2Deice;
                    } else {
                        deicing.type2Deice = [];
                    }

                    deicings.push(deicing);
                }

                setFormData(deicings);

                // if (deicing?.oneTwoDeice === "twoDeice") {
                //     setOneTwoDeice("twoDeice");
                // }
            }
        } catch (err) {
            throw err;
        }
    }

    const loadAirlines = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/airline/getAll"
                })
            );

            if (res?.data?.airlines?.length > 0) {

                setCompanies(res?.data?.airlines.map(airline => ({ value: airline.code, label: airline.name })));
            }
        } catch (err) {
            throw err;
        }
    }

    const loadWeatherList = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/weather/getAll"
                })
            );

            if (res?.data?.weather?.length > 0) {

                setWeatherList(res?.data?.weather.map(weather => ({ value: weather.id, label: weather.name })));
            }
        } catch (err) {
            throw err;
        }
    }

    const getFlight = async (aircraftRegistration: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/flightList/get",
                    data: {
                        aircraftRegistration: aircraftRegistration
                    }
                })
            );

            return res.data.flight
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const getDeicingItem = async (deicingId: string, field: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicingitem/get",
                    data: {
                        deicingId: deicingId,
                        field: field
                    }
                })
            );

            return res.data.deicing_item;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const loadRepeatDeicingReason = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/repeatdeicingreason/getAll"
                })
            );

            if (res?.data?.repeatDeicingReason?.length > 0) {

                setRepeatDeicingReason(res?.data?.repeatDeicingReason.map(repeatdeicingReason => ({ value: repeatdeicingReason.id, label: repeatdeicingReason.name })));
            }
        } catch (err) {
            throw err;
        }
    }

    const insertDeicing = async (deicing: DeicingFormData) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicing/insert",
                    data: {
                        ...deicing,
                        stockId: selectedStock?.id,
                        oneTwoDeice: oneTwoDeice,
                        //date: deicingDate
                        // type1Start: deicing.type1Start ? new Date(deicing.type1Start) : null,
                        // type1End: deicing.type1End ? new Date(deicing.type1End) : null
                    }
                })
            );

            return res.data.id;
        } catch (err) {
            throw err;
        }
    }

    const removeDeicingItem = async (deicingId: string) => {
        try {
            await (
                axios({
                    method: "post",
                    url: "api/deicingitem/remove",
                    data: {
                        deicing: deicingId
                    }
                })
            );

        } catch (err) {
            throw err;
        }
    }

    const updateDeicing = async (deicing: DeicingFormData) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicing/update",
                    data: {
                        ...deicing,
                        checked: checkedState,
                        checkedBy: checkedState ? Number(loggedUser?.id!) : null,
                        checkedByName: checkedState ? loggedUser?.name2 ?? null : null,
                        weatherCode: weatherCodeState,
                        lastModified: toLocalDateTimeOffset(new Date()),
                        checkedDate: checkedState ? toLocalDateTimeOffset(new Date()) : null,
                        modifiedBy: Number(loggedUser?.id!),
                    }
                })
            );

            return res.data.id;
        } catch (err) {
            throw err;
        }
    }

    const insertDeicingItem = async (deicingItem: DeicingFormItem, deicingId: string, field: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/deicingitem/insert",
                    data: {
                        ...deicingItem,
                        deicing: deicingId,
                        field: field
                    }
                })
            );

            return res.data.id;
        } catch (err) {
            throw err;
        }
    }

    const updateAircraftData = (e) => {

        updateField(
            "aircraftRegistration",
            e.target.value
        )
        // load aircraft data from service
        // set aircraft attributes
    }

    const handleFlightList = () => {
        setDisplayFlightList(true);
    };

    // const addDeiceItemType1 = () => {
    //     setFormData(prevState => {
    //         return {
    //             ...prevState,
    //             type1Deice: [...prevState.type1Deice || [], {
    //                 type1FluidConsumption: null,
    //                 fluidRatio: null,
    //                 waterConsumption: null
    //             }]
    //         }
    //     })
    // }

    // const addDeiceItemType2 = () => {
    //     setFormData(prevState => {
    //         return {
    //             ...prevState,
    //             type2Deice: [...prevState.type2Deice || [], {
    //                 type1FluidConsumption: null,
    //                 fluidRatio: null,
    //                 waterConsumption: null
    //             }]
    //         }
    //     })
    // }

    // const loadFlight = async () => {
    //     if (formData?.aircraftRegistration) {
    //         const flight = await getFlight(formData?.aircraftRegistration);

    //         if (flight?.length > 0) {
    //             setFormData(prevState => {
    //                 return {
    //                     ...prevState,
    //                     company: flight[0]?.company,
    //                     flightNumber: flight[0]?.flight_number,
    //                     aircraftRegistration: flight[0]?.aircraft_registration,
    //                     aircraftType: flight[0]?.aircraft_type,
    //                     stand: flight[0]?.stand
    //                 };
    //             });
    //         } else {
    //             setShowDialog(true);
    //         }
    //     }
    // };

    const onClickBackFlightList = () => {
        setDisplayFlightList(false);
    }

    const onClickSelectFlightFlightList = (flight: any) => {
        setDisplayFlightList(false);

        setFormData(prevState => {
            return {
                ...prevState,
                company: flight?.company,
                flightNumber: flight?.flight_number,
                aircraftRegistration: flight?.aircraft_registration,
                aircraftType: flight?.aircraft_type,
                stand: flight?.stand
            };
        });
    }

    const updateDeiceItem = <K extends keyof DeicingFormItem>(
        type: "type1Deice" | "type2Deice",
        index: number,
        field: K,
        value: DeicingFormItem[K]
    ) => {
        setFormData(prev => ({
            ...prev,
            [type]: prev[type].map((item, i) =>
                i === index
                    ? { ...item, [field]: value }
                    : item
            ),
            lastModified: toLocalDateTimeOffset(new Date()),
            modifiedBy: Number(loggedUser?.id!),
        }));
    };

    if (displayFlightList) {
        return (
            <FlightListComp
                onClickBack={onClickBackFlightList}
                onClickSelect={onClickSelectFlightFlightList}
            />
        );
    }

    return <>
        {showDialog && <DialogWindow
            displayDialog={showDialog}
            setDisplayDialog={setShowDialog}
            title={"Nenalezen žádný let se zadanou imatrikulací. Let vyberte ze seznamu letů nebo zadejte ručně."}
            cancelText={"OK"}
        />}
        <Card
            title="Kontrola"
            displaySelectedStock={false}
            displayLogo={false}
        >
            <form className="deicing-check-form">

                {/* {(operationCode === "repeatDeicing" || (selectedDeicing && formData.repeatDeicingReason)) && <section className="form-section">
          <h3>Opakovaný odmraz</h3>

          <div className="form-grid">
            <SelectField
              label="Důvod opakování"
              value={formData.repeatDeicingReason}
              options={repeatDeicingReason}
              onChange={value => updateField("repeatDeicingReason", Number(value))}
            />
          </div>

          <div />

          <label className="wheatherConditions">
            Poznámka
            <textarea
              rows={4}
              value={formData.noteRepeatDeicing}
              onChange={event => updateField("noteRepeatDeicing", event.target.value)}
            />
          </label>
        </section>} */}

                <section className="form-section">
                    <h3>Letadlo</h3>

                    <div className="form-grid">
                        <div>
                            <strong>Imatrikulace letadla:</strong> {formData[0]?.aircraftRegistration}
                        </div>

                        <div>
                            <strong>Stojánka:</strong> {formData[0]?.standName}
                        </div>

                        <div>
                            <strong>Společnost:</strong> {formData[0]?.companyName}
                        </div>

                        <div>
                            <strong>Typ letadla:</strong> {formData[0]?.aircraftType}
                        </div>

                        <div>
                            <strong>Číslo letu:</strong> {formData[0]?.flightNumber}
                        </div>
                    </div>
                </section>

                <section className="form-section">
                    <h3>Podmínky</h3>

                    {/* <div className="form-grid">
                        <div>
                            <strong>OAT [°C]:</strong> {formData[0]?.oat}
                        </div>

                        <div>
                            <strong>Teplota křídel [°C]:</strong> {formData[0]?.wingTemperature}
                        </div>

                        <div>
                            <strong>Poznámka:</strong> {formData[0]?.note}
                        </div>
                    </div> */}

                    <div className="deicing-summary">
                        {formData?.map((deiceItem, index) => (
                            <div
                                className="deicing-summary-item"
                                key={deiceItem.id ?? index}
                            >
                                <div className="deicing-summary-header">
                                    <span>{deiceItem.stockName || "-"}</span>
                                </div>

                                <div className="deicing-stage">
                                    <div className="summary-grid">
                                        <div className="summary-value">
                                            <span>OAT [°C]</span>
                                            <div>{deiceItem?.oat || "-"}</div>
                                        </div>

                                        <div className="summary-value">
                                            <span>Teplota křídel [°C] - nastavená teplota ve vozidle</span>
                                            <div>{deiceItem?.wingTemperature || "-"}</div>
                                        </div>
                                        <div className="summary-value">
                                            <span>Poznámka</span>
                                            <div>
                                                {deiceItem?.note || "-"}
                                            </div>
                                        </div>
                                    </div>
                                    {deiceItem?.oat && deiceItem?.wingTemperature && Number(deiceItem?.oat) < Number(deiceItem?.wingTemperature) && <div className="validation-warning">
                                        ⚠ Teplota OAT musí být vyšší nebo rovna teplotě křídel.
                                    </div>}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* <label className="wheatherConditions">
                        Poznámka
                        <textarea
                            rows={4}
                            value={formData.note}
                            onChange={event => updateField("note", event.target.value)}
                        />
                    </label> */}
                </section>

                {/* {selectedDeicing && !operationCode && loggedUser?.userrole === "kontrola" && <section className="form-section">
                    <h3>Kontrola</h3>

                    <div className="form-grid">
                        <label className="checkbox-field">
                            <input
                                type="checkbox"
                                checked={formData.checked}
                                onChange={handleCheckedChange}
                            />
                            Zkontrolováno
                        </label>

                        <label>
                            Zkontroloval
                            <input type="text" value={formData?.checkedByName ?? undefined} readOnly />
                        </label>
                    </div>
                </section>} */}

                {/* <section className="form-section">
                    <h3>Stupeň odmrazování</h3>
                    <div className="toggle">
                        <button
                            type="button"
                            className={oneTwoDeice === "oneDeice" ? "active" : ""}
                            onClick={() => setOneTwoDeice("oneDeice")}
                        >
                            Jednostupňové
                        </button>

                        <button
                            type="button"
                            className={oneTwoDeice === "twoDeice" ? "active" : ""}
                            onClick={() => setOneTwoDeice("twoDeice")}
                        >
                            Dvoustupňové
                        </button>
                    </div>
                </section> */}

                {/* <section className="form-section">
                    <h3>Odmrazování</h3>

                    {formData?.map(deiceItem => {
                        return <>
                            <div>
                                <strong>Vozidlo:</strong> {deiceItem.stockName}
                            </div>

                            <div>
                                <strong>První stupeň odmrazování:</strong>
                            </div>

                            < div className="form-grid">

                                <div>
                                    <strong>Začátek:</strong> {deiceItem.type1Start}
                                </div>

                                <div>
                                    <strong>Konec:</strong> {deiceItem.type1End}
                                </div>
                            </div>

                            <div className="form-grid deice-item">
                                {deiceItem?.type1Deice?.map((typeDeice) => {

                                    // const [leftFluidRation = "", rightFluidRatio = ""] = (typeDeice.fluidRatio ?? "").split("/");

                                    return <>
                                        <div>
                                            <strong>Poměr kapalin:</strong> {typeDeice.fluidRatio}
                                        </div>

                                        <div>
                                            <strong>Spotřeba kapaliny I [litr]:</strong> {typeDeice.type1FluidConsumption}
                                        </div>

                                        <div>
                                            <strong>Spotřeba vody [litr]:</strong> {typeDeice.waterConsumption}
                                        </div>
                                        <div />
                                    </>
                                })}
                            </div>

                            {deiceItem.oneTwoDeice === "twoDeice" && <>
                                <div>
                                    <strong>Druhý stupeň odmrazování:</strong>
                                </div>
                                < div className="form-grid">

                                    <div>
                                        <strong>Začátek:</strong> {deiceItem.type2Start}
                                    </div>

                                    <div>
                                        <strong>Konec:</strong> {deiceItem.type2End}
                                    </div>

                                    <div>
                                        <strong>Spotřeba kapaliny II [litr]:</strong> {deiceItem.type3FluidConsumption}
                                    </div>

                                    <div />
                                </div>

                                <div className="form-grid deice-item">
                                    {deiceItem?.type2Deice?.map((typeDeice) => {

                                        return <>
                                            <div>
                                                <strong>Poměr kapalin:</strong> {typeDeice.fluidRatio}
                                            </div>

                                            <div>
                                                <strong>Spotřeba kapaliny I [litr]:</strong> {typeDeice.type1FluidConsumption}
                                            </div>

                                            <div>
                                                <strong>Spotřeba vody [litr]:</strong> {typeDeice.waterConsumption}
                                            </div>
                                            <div />
                                        </>
                                    })}
                                </div>
                            </>}
                        </>
                    })
                    }
                </section> */}

                <section className="form-section">
                    <h3>Odmrazování</h3>

                    <div className="deicing-summary">
                        {formData?.map((deiceItem, index) => (
                            <div
                                className="deicing-summary-item"
                                key={deiceItem.id ?? index}
                            >
                                <div className="deicing-summary-header">
                                    <span>{deiceItem.stockName || "-"}</span>
                                </div>

                                <div className="deicing-stage">
                                    <h4>První stupeň odmrazování</h4>

                                    <div className="summary-grid">
                                        <div className="summary-value">
                                            {/* <span>Začátek</span> */}
                                            {/* <div>{deiceItem.type1Start || "-"}</div> */}
                                            <DateTimeField
                                                label="Začátek"
                                                value={deiceItem.type1Start}
                                                onChange={value => updateFieldData(deiceItem.id, "type1Start", value)}
                                                onSetCurrentTime={function (): void {
                                                    throw new Error("Function not implemented.");
                                                }}
                                            />
                                        </div>

                                        <div className="summary-value">
                                            {/* <span>Konec</span> */}
                                            {/* <div>{deiceItem.type1End || "-"}</div> */}
                                            <DateTimeField
                                                label="Konec"
                                                value={deiceItem.type1End}
                                                onChange={value => updateFieldData(deiceItem.id, "type1End", value)}
                                                onSetCurrentTime={function (): void {
                                                    throw new Error("Function not implemented.");
                                                }}
                                            />
                                        </div>
                                        <div className="summary-value">
                                            <span>Poznámka</span>
                                            <div>
                                                {deiceItem?.note || "-"}
                                            </div>
                                        </div>
                                    </div>

                                    {deiceItem.type1Deice?.map((typeDeice, typeIndex) => (<>
                                        <div
                                            className="deicing-fluid"
                                            key={typeIndex}
                                        >
                                            <div className="summary-value">
                                                <span>Poměr kapalin</span>
                                                <div>{typeDeice.fluidRatio || "-"}</div>
                                            </div>

                                            <div className="summary-value">
                                                <span>Spotřeba kapaliny I</span>
                                                <div>{typeDeice.type1FluidConsumption ?? "-"} l</div>
                                            </div>

                                            <div className="summary-value">
                                                <span>Spotřeba vody</span>
                                                <div>{typeDeice.waterConsumption ?? "-"} l</div>
                                            </div>

                                            <div className="summary-value">
                                                <span>Poznámka</span>
                                                <div>
                                                    {typeDeice?.note || "-"}
                                                </div>
                                            </div>

                                        </div>
                                        {typeDeice.fluidRatio && typeDeice.type1FluidConsumption && typeDeice.waterConsumption &&
                                            !fluidRatioVsFluidConsumption(typeDeice.fluidRatio, typeDeice.type1FluidConsumption, typeDeice.waterConsumption) &&
                                            <div className="validation-warning">
                                                ⚠ Spotřeba kapaliny a vody neodpovídá zadanému poměru.
                                            </div>
                                        }
                                        {!checkFluidMaxRatio(typeDeice.fluidRatio) &&
                                            <div className="validation-warning">
                                                ⚠ Kapalina nemůže tvořit více jak 69% z celkového množství.
                                            </div>
                                        }
                                    </>
                                    ))}
                                </div>

                                {deiceItem.oneTwoDeice === "twoDeice" && (
                                    <div className="deicing-stage">
                                        <h4>Druhý stupeň odmrazování</h4>

                                        <div className="summary-grid">
                                            <div className="summary-value">
                                                {/* <span>Začátek</span>
                                                <div>{deiceItem.type2Start || "-"}</div> */}
                                                <DateTimeField
                                                    label="Začátek"
                                                    value={deiceItem.type2Start}
                                                    onChange={value => updateFieldData(deiceItem.id, "type2Start", value)}
                                                    onSetCurrentTime={function (): void {
                                                        throw new Error("Function not implemented.");
                                                    }}
                                                />
                                            </div>

                                            <div className="summary-value">
                                                {/* <span>Konec</span>
                                                <div>{deiceItem.type2End || "-"}</div> */}
                                                <DateTimeField
                                                    label="Konec"
                                                    value={deiceItem.type2End}
                                                    onChange={value => updateFieldData(deiceItem.id, "type2End", value)}
                                                    onSetCurrentTime={function (): void {
                                                        throw new Error("Function not implemented.");
                                                    }}
                                                />
                                            </div>

                                            {deiceItem?.type3FluidConsumption && <div className="summary-value">
                                                <span>Spotřeba kapaliny II</span>
                                                <div>
                                                    {deiceItem.type3FluidConsumption} l
                                                </div>
                                            </div>}
                                            <div className="summary-value">
                                                <span>Poznámka</span>
                                                <div>
                                                    {deiceItem?.note || "-"}
                                                </div>
                                            </div>
                                        </div>

                                        {deiceItem.type2Deice?.map((typeDeice, typeIndex) => (<>
                                            <div
                                                className="deicing-fluid"
                                                key={typeIndex}
                                            >
                                                <div className="summary-value">
                                                    <span>Poměr kapalin</span>
                                                    <div>{typeDeice.fluidRatio || "-"}</div>
                                                </div>

                                                <div className="summary-value">
                                                    <span>Spotřeba kapaliny I</span>
                                                    <div>{typeDeice.type1FluidConsumption ?? "-"} l</div>
                                                </div>

                                                <div className="summary-value">
                                                    <span>Spotřeba vody</span>
                                                    <div>{typeDeice.waterConsumption ?? "-"} l</div>
                                                </div>

                                                <div className="summary-value">
                                                    <span>Poznámka</span>
                                                    <div>
                                                        {typeDeice?.note || "-"}
                                                    </div>
                                                </div>
                                            </div>
                                            {typeDeice.fluidRatio && typeDeice.type1FluidConsumption && typeDeice.waterConsumption &&
                                                !fluidRatioVsFluidConsumption(typeDeice.fluidRatio, typeDeice.type1FluidConsumption, typeDeice.waterConsumption) &&
                                                <div className="validation-warning">
                                                    ⚠ Spotřeba kapaliny a vody neodpovídá zadanému poměru.
                                                </div>
                                            }
                                            {!checkFluidMaxRatio(typeDeice.fluidRatio) &&
                                                <div className="validation-warning">
                                                    ⚠ Kapalina nemůže tvořit více jak 69% z celkového množství.
                                                </div>
                                            }
                                        </>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </section>

                <section className="form-section">
                    <h3>Souhrn</h3>

                    <div className="form-grid">

                        <label>
                            Spotřeba kapaliny I
                            <input
                                type="text"
                                value={`${totalConsumption} l`}
                                readOnly
                            />
                        </label>

                        <label>
                            Spotřeba kapaliny II
                            <input
                                type="text"
                                value={`${fluidType2Consumption} l`}
                                readOnly
                            />
                        </label>

                        <label>
                            Spotřeba vody
                            <input
                                type="text"
                                value={`${waterConsumption} l`}
                                readOnly
                            />
                        </label>

                        <label>
                            Čas odmrazení
                            <input
                                type="text"
                                value={`${deicingDurationMinutes} min`}
                                readOnly
                            />
                        </label>
                    </div>
                </section>

                {selectedDeicing && !operationCode && (loggedUser?.userrole === "kontrola" || loggedUser?.userrole === "admin") && <section className="form-section">
                    <h3>Kontrola</h3>

                    <div className="form-grid">
                        <SelectField
                            label="Počasí"
                            value={weatherCodeState}
                            options={weatherList}
                            onChange={value => setWeatherCodeState(Number(value))} />

                        <div />

                        <label className="checkbox-field">
                            <input
                                type="checkbox"
                                checked={checkedState}
                                onChange={handleCheckedChange}
                            />
                            Zkontrolováno
                        </label>

                        <label>
                            Zkontroloval
                            <input
                                type="text"
                                value={checkedByNameState ?? undefined} readOnly
                            />
                        </label>
                    </div>
                    <div className="check-text">Kontrola čistého ledu provedena, led nenalezen. Letadlo nebylo při odmrazování poškozeno. Kontrola po odmrazování (ochrana proti námraze) byla provedena.</div>
                </section>}

                {/*  {selectedDeicing && !operationCode && <section className="form-section">
                    <h3>Systémové údaje</h3>

                    <div className="form-grid">
                        <label>
                            Poslední úprava
                            <input
                                type="datetime-local"
                                value={formData?.lastModified ? toLocalDateTime(formData.lastModified) : undefined}
                                readOnly
                            />
                        </label>

                        <label>
                            Upravil
                            <input type="text" value={formData?.modifiedByName} readOnly />
                        </label>
                    </div>
                </section>} */}

                {/* <div className="form-actions">
          <button type="submit">Uložit záznam</button>
        </div> */}

                <div className="item-list-actions">
                    <FloatingActions actions={actions} />
                </div>

            </form>
        </Card >
    </>;
};

// interface DateTimeFieldProps {
//   label: string;
//   value: string | null;
//   onChange: (value: string) => void;
//   onSetCurrentTime: () => void;
// }

// const DateTimeField: React.FC<DateTimeFieldProps> = ({
//   label,
//   value,
//   onChange,
//   onSetCurrentTime,
// }) => (
//   <div className="date-time-field">
//     <label>
//       {label}
//       <input
//         type="datetime-local"
//         value={value ?? undefined /*toLocalDateTimeOffset(value) : undefined*/}
//         onChange={event => onChange(event.target.value)}
//       />
//     </label>

//     <button type="button" onClick={onSetCurrentTime}>
//       Nastavit aktuální čas
//     </button>
//   </div>
// );

interface DateTimeFieldProps {
    label: string;
    value: string | null;
    onChange: (value: string | null) => void;
    onSetCurrentTime: () => void;
    disabled?: boolean;
}

const DateTimeField: React.FC<DateTimeFieldProps> = ({
    label,
    value,
    onChange,
    onSetCurrentTime,
    disabled = false,
}) => {
    return (
        <div className="date-time-field">
            <div className="date-time-field__label">
                <span className="date-time-field__label-text">
                    {label}
                </span>

                <DateTimeInput
                    className="date-time-field__input"
                    aria-label={label}
                    value={value ?? ""}
                    disabled={disabled}
                    onChange={value => onChange(value || null)}
                />
            </div>

            {/* <button
                className="date-time-field__button"
                type="button"
                disabled={disabled}
                onClick={onSetCurrentTime}
            >
                Nastavit aktuální čas
            </button> */}
        </div>
    );
};

interface NumberFieldProps {
    label: string;
    value: number | null;
    min?: number;
    max?: number;
    onChange: (value: number | null) => void;
    readOnly?: boolean;
}

const NumberField: React.FC<NumberFieldProps> = ({
    label,
    value,
    min,
    max,
    onChange,
    readOnly = false
}) => (
    <label>
        {label}
        <input
            type="number"
            value={value ?? undefined}
            min={min}
            max={max}
            step={1}
            onChange={event =>
                onChange(
                    event.target.value === ""
                        ? null
                        : Number(event.target.value)
                )
            }
            readOnly={readOnly}
        />
    </label>
);

interface SelectFieldProps {
    label: string;
    value: string | number | null | undefined;
    options: Option[];
    onChange: (value: string) => void;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    value,
    options,
    onChange,
}) => (
    <label>
        {label}
        <select
            value={value ?? undefined}
            onChange={event => onChange(event.target.value)}
        >
            <option value="">Vyberte hodnotu</option>

            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    </label>
);

export default DeicingCheckForm;

// import DeicingForm, {
//   DeicingFormData,
// } from "./DeicingForm";

// const App = () => {
//   const handleSubmit = (data: DeicingFormData) => {
//     console.log("Submitted data:", data);
//   };

//   return (
//     <DeicingForm
//       currentUserName="Martin Sommer"
//       stands={[
//         { value: "A1", label: "A1" },
//         { value: "A2", label: "A2" },
//         { value: "B1", label: "B1" },
//       ]}
//       companies={[
//         { value: "csa", label: "České aerolinie" },
//         { value: "smartwings", label: "Smartwings" },
//       ]}
//       weatherCodes={[
//         { value: "SN", label: "SN – sněžení" },
//         { value: "FZRA", label: "FZRA – namrzající déšť" },
//         { value: "FG", label: "FG – mlha" },
//       ]}
//       onSubmit={handleSubmit}
//     />
//   );
// };

// export default App;
